import { memo } from 'react';

import { SimilarToAssetChip } from '~/components/SearchCommand/SmartSearchImageSearchStatus/SimilarToAssetChip';

export type ImageUploadSearchProps = {
  similarToImage: string;
};

export const ImageUploadSearch = memo(({ similarToImage }: ImageUploadSearchProps) => {
  const image = (
    // biome-ignore lint/performance/noImgElement: src is base64 image
    <img
      src={similarToImage}
      // biome-ignore lint/a11y/noRedundantAlt: "Search by uploaded image" is a descriptive alt text
      alt="Search by uploaded image"
      className="ui2026:block ui2026:size-full h-6 w-6 shrink-0 rounded-4 object-cover [image-rendering:smooth]"
    />
  );

  return (
    <SimilarToAssetChip data-testid="IMAGE_UPLOAD_SEARCH" image={image}>
      Uploaded image
    </SimilarToAssetChip>
  );
});

ImageUploadSearch.displayName = 'ImageUploadSearch';
